module.exports = __webpack_public_path__ + "img/car_00045.266e0c52.jpg";